/**
 * Created by Ning Jiang on 2022-06-15.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Serial} from "../Serial";
import {SerialGameMode} from "../server/SerialGameMode";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {SerialSound} from "../sound/SerialSound";

export class WinCapWinPresentation implements FlowStatePresentation {

    constructor() {}

    public async start(flowStateController:FlowStateController):Promise<any> {
        Serial.background.screenTransition.stopLoop();
        Serial.background.screenTransition.hide();
        SerialSound.soundPlayer.stopTrack(SerialSound.WIN_CAP_TRANSITION_LOOP);
        if(Serial.model.parsedGameData.nextMode != SerialGameMode.CAPWIN_GAME) {
            SerialSound.PLAYING_LOOP_EFFECT = "";
            for(let i = 0; i < 3; i++) {
                SerialSound.soundPlayer.stopTrack(SerialSound.WIN_CAP_LOOP[i]);
            }
            SerialSound.soundPlayer.playTrack({name : SerialSound.WIN_CAP_END});

            if(Serial.model.parsedGameData.maximumWinAchieved) {
                await Serial.winCapController.playWinPresentation(Serial.model.parsedGameData.maxWinLevel);
            } else {
                await Serial.winCapController.playFailedPresentation(Serial.model.parsedGameData.maxWinLevel);
            }
            await Serial.winCapController.showEnding();
            Serial.background.setMode(GameMode.NORMAL);
            Serial.background.tweenDimmer(0, 0.3);
            Serial.keypadPlugin.setZeroBetSpinCounter(-1);
        }
        flowStateController.finish();
    }
}